<template>
  <div class="hockey-field">
    <h4>Поле {{ fieldId }}</h4>
    <div class="field-container">
      <div class="field">
        <!-- Players assigned to this field -->
        <div v-for="player in assignedPlayers" :key="player.id" class="player-token" @click="unassignPlayer(player)">
          {{ player.last_name ? player.last_name.charAt(0) : player.first_name ? player.first_name.charAt(0) : '?' }}
        </div>
        
        <!-- Empty slots -->
        <div v-for="n in (6 - assignedPlayers.length)" :key="`empty-${n}`" class="empty-slot" @click="showPlayerList">
          +
        </div>
      </div>
    </div>

    <!-- Player selection dropdown -->
    <ScrollableDropdown 
      :available-players="availablePlayers"
      :field-id="fieldId"
      @player-assign="assignPlayer"
    />
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import ScrollableDropdown from './ScrollableDropdown.vue';

export default {
  components: {
    ScrollableDropdown,
  },
  name: 'HockeyField',
  props: {
    fieldId: {
      type: Number,
      required: true,
    },
    players: {
      type: Array,
      required: true,
    },
    allAssignedPlayers: {
      type: Array,
      required: true,
    },
  },
  emits: ['player-assign', 'player-unassign'],
  setup(props, { emit }) {
    const assignedPlayers = computed(() => {
      return props.allAssignedPlayers
        .filter(p => p.fieldId === props.fieldId)
        .map(p => props.players.find(player => player.id === p.playerId))
        .filter(Boolean);
    });

    const availablePlayers = computed(() => {
      const assignedPlayerIds = props.allAssignedPlayers.map(p => p.playerId);
      return props.players.filter(p => 
        p.is_participating === 2 && // Only participating players
        !assignedPlayerIds.includes(p.id)
      );
    });

    const showPlayerList = () => {
      if (assignedPlayers.value.length < 6) {
        // Dropdown теперь управляется в ScrollableDropdown
      }
    };

    const assignPlayer = (fieldId, playerId) => {
      emit('player-assign', fieldId, playerId);
    };

    const unassignPlayer = (player) => {
      emit('player-unassign', props.fieldId, player.id);
    };

    return {
      assignedPlayers,
      availablePlayers,
      showPlayerList,
      assignPlayer,
      unassignPlayer,
    };
  },
};
</script>

<style scoped>
.hockey-field {
  margin-bottom: var(--spacing-lg);
}

.field-container {
  border: 2px solid var(--color-primary);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-md);
  margin-top: var(--spacing-sm);
}

.field {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--spacing-md);
  padding: var(--spacing-md);
}

.player-token {
  background-color: var(--color-primary);
  color: var(--color-bg-primary);
  width: 40px;
  height: 40px;
  border-radius: var(--border-radius-circle);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  transition: transform var(--transition-fast);
}

.player-token:hover {
  transform: scale(1.1);
}

.empty-slot {
  width: 40px;
  height: 40px;
  border: 2px dashed var(--color-text-tertiary);
  border-radius: var(--border-radius-circle);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-tertiary);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.empty-slot:hover {
  border-color: var(--color-primary);
  color: var(--color-primary);
  transform: scale(1.1);
}


</style> 